<template>
    <div>

        <div class="position-relative">
            <!-- shape Hero -->
            <section class="section-shaped my-0">
                <div class="shape shape-style-1 shape-dark shape-skew">
                    <span></span>
                    <span></span>
                    <span></span>
                    <span></span>
                    <span></span>
                    <span></span>
                    <span></span>
                    <span></span>
                    <span></span>
                </div>
                <div class="container shape-container d-flex">
                    <div class="col px-0">
                        <div class="row">
                            <div class="col-lg-6">
                                <h1 class="display-3  text-white">Software Projects
                                    <!--<span>and the sort</span>-->
                                </h1>
                                <p class="lead  text-white">I work on a variety of software projects (from writing code
                                    to adding art). A select few are publicly displayed,
                                    and a few of those are "production ready." Most of the projects are meant for
                                    exploring new ideas or fun. You can find my full github at <a href="https://github.com/rushnett" target="_blank">@rushnett</a>.</p>
                                <!--<div class="btn-wrapper">
                                    <base-button tag="a"
                                                 href="https://demos.creative-tim.com/argon-design-system/docs/components/alerts.html"
                                                 class="mb-3 mb-sm-0"
                                                 type="info"
                                                 icon="fa fa-code">
                                        Components
                                    </base-button>
                                    <base-button tag="a"
                                                 href="https://www.creative-tim.com/product/argon-design-system"
                                                 class="mb-3 mb-sm-0"
                                                 type="white"
                                                 icon="ni ni-cloud-download-95">
                                        Download HTML
                                    </base-button>
                                </div>-->
                            </div>
                        </div>
                    </div>
                </div>
            </section>
            <!-- 1st Hero Variation -->
        </div>

        <section v-for="(section, i) in sections" :id="section.id" v-bind:class="{'section': true, 'section-lg': i%2 === 0, 'bg-secondary': i%2 !== 0}">
            <div class="container">
                <div class="row row-grid align-items-center">
                    <div class="col-md-6 order-md-2">
                        <img :src="section.img" class="img-fluid rounded">
                    </div>
                    <div class="col-md-6 order-md-1">
                        <div class="pr-md-5">
                            <icon class="mb-5" size="lg" type="success" shadow
                                  rounded>
                                <font-awesome-icon :icon="section.mainIcon"></font-awesome-icon>
                            </icon>
                            <h3>{{ section.title }}</h3>
                            <p v-html="section.desc"></p>
                            <ul class="list-unstyled mt-5">
                                <li class="py-2" v-for="(tag, i) in section.tags">
                                    <div class="d-flex align-items-center">
                                        <badge type="success" circle class="mr-3">
                                            <font-awesome-icon :icon="tag.icon"></font-awesome-icon>
                                        </badge>
                                        <h6 class="mb-0">{{ tag.title }}</h6>
                                    </div>
                                </li>
                            </ul>
                            <base-button v-for="(button, i) in section.buttons"
                                         tag="a"
                                         :href="button.link"
                                         target="_blank"
                                         class="mb-3 mb-sm-0 text-white"
                                         :type="button.color">
                                <font-awesome-icon v-if="button.icon" :icon="button.icon" size="lg"></font-awesome-icon>
                                {{ button.title }}
                                <!--href="https://www.creative-tim.com/product/vue-argon-design-system"-->
                            </base-button>
                        </div>
                    </div>
                </div>
            </div>
        </section>


        <section class="section section-lg">

        </section>

    </div>
</template>

<script>
  export default {
    name: 'home',
    components: {},
    data: () => ({
      sections: require('../../public/details/software'),
    }),
    methods: {
      goToLink (url) {
        let win = window.open(url, '_blank')
        win.focus()
      }
    }
  }
</script>
